import React, { useState, useEffect } from "react";
import Header from "./Components/Header.jsx";
import Sidebar from "./Components/Sidebar.jsx";
import Dashboard from "./Components/Dashboard.jsx";
import OwnerDashboard from "./Components/OwnerDashboard.jsx";
import { ethers } from "ethers";
import StakingAbi from "../../../Staking.json";
import "./StakingDashboard.css";

function StakingDashboard({ account }) {
  const [view, setView] = useState("dashboard");
  const [isOwner, setIsOwner] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const contractAddress = "0xf57ae70f5e25c4617973c812d5beb5e7a2d90c6e";
  const staking_abi = StakingAbi;
  const [contractInstance, setContractInstance] = useState(null);

  useEffect(() => {
    // Function to determine if the device is mobile or tablet
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }

    async function loadContract() {
      try {
        if (account && window.ethereum) {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            staking_abi,
            signer
          );
          const paused = await contract.paused();
          setIsPaused(paused);
          setContractInstance(contract);
          if (account === "0x83aB680a4BEc9b8be243FDf790D920DEbFb968FD") {
            setIsOwner(true);
          }
        } else {
          console.log("Ethereum wallet is not available.");
          setIsOwner(false);
        }
      } catch (error) {
        console.error("Error loading contract:", error);
      }
    }

    if (isMobileDevice()) {
      alert(
        "Please use a desktop computer or MetaMask browser to access the Staking Dashboard."
      );
    } else {
      loadContract();
    }
  }, [account]);

  const handleEmergencyWithdraw = async () => {
    if (!contractInstance) return;
    try {
      const tx = await contractInstance.emergencyWithdraw(0); // Assuming 0 as a sample index
      await tx.wait();
      alert("Emergency withdrawal successful!");
    } catch (error) {
      alert("Error with emergency withdrawal: " + error.message);
    }
  };

  return (
    <div className="Staking-Dashboard-App">
      <div
        className={`Staking-Dashboard-main ${
          isSidebarOpen ? "sidebar-open" : ""
        }`}
      >
        <Header
          account={account}
          contract={contractInstance}
          setView={setView}
          view={view}
          isOwner={isOwner}
          isPaused={isPaused}
          handleEmergencyWithdraw={handleEmergencyWithdraw}
        />
        {view === "dashboard" && (
          <Dashboard account={account} contract={contractInstance} />
        )}
        {view === "owner" && (
          <OwnerDashboard account={account} contract={contractInstance} />
        )}
      </div>
    </div>
  );
}

export default StakingDashboard;
